/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
import _regeneratorRuntime from "E:\\ysh\\wx-master\\node_modules\\_@babel_runtime@7.16.5@@babel\\runtime\\regenerator\\index.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
/*
 * @Description:
 * @Date: 2020-09-21 15:41:18
 */


import { kernel } from '@/utils/tools.js';
import { jsApiSignature } from '@/api/ajax';
import wx from 'weixin-js-sdk';
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
    var defaultArg, title, link, target, imgUrl, desc, callback, shareUrl, _yield$jsApiSignature, _yield$jsApiSignature2, appId, timestamp, nonceStr, signature;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            defaultArg = {
              title: '',
              link: window.location.href,
              target: '',
              imgUrl: '',
              desc: '',
              callback: null
            };
            Object.assign(defaultArg, args);
            title = defaultArg.title, link = defaultArg.link, target = defaultArg.target, imgUrl = defaultArg.imgUrl, desc = defaultArg.desc, callback = defaultArg.callback; // alert(target, link);

            shareUrl = target || link;

            if (!(kernel() === 'wx')) {
              _context.next = 15;
              break;
            }

            _context.next = 7;
            return jsApiSignature({
              url: link
            });

          case 7:
            _yield$jsApiSignature = _context.sent;
            _yield$jsApiSignature2 = _yield$jsApiSignature.data.data;
            appId = _yield$jsApiSignature2.appId;
            timestamp = _yield$jsApiSignature2.timestamp;
            nonceStr = _yield$jsApiSignature2.nonceStr;
            signature = _yield$jsApiSignature2.signature;
            wx.config({
              debug: false,
              appId: appId,
              timestamp: timestamp,
              nonceStr: nonceStr,
              signature: signature,
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'previewImage', 'openLocation', 'getLocation']
            });
            wx.ready(function () {
              // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
              wx.onMenuShareTimeline({
                title: title,
                // 分享标题
                link: shareUrl,
                // 分享链接
                imgUrl: imgUrl,
                // 分享图标
                success: function success() {
                  if (callback) {
                    callback();
                  }
                },
                cancel: function cancel() {}
              });
              wx.onMenuShareAppMessage({
                title: title,
                // 分享标题
                link: shareUrl,
                // 分享链接
                imgUrl: imgUrl,
                // 分享图标
                desc: desc,
                // 分享描述
                type: 'link',
                // 分享类型,music、video或link，不填默认为link
                dataUrl: '',
                // 如果type是music或video，则要提供数据链接，默认为空
                success: function success() {
                  if (callback) {
                    callback();
                  }
                },
                cancel: function cancel() {}
              });
            });

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();